export default __webpack_public_path__ + "static/media/fv_logistic.a5af9bbc.svg";